import instance from '@apis/instance';
import { PageResponse, SliceResponse } from '@models/page';
import {
    GetPointCardsParams, GetPointHistoryParams, PointCardRow, PointHistoryRow,
} from '@models/point';

class PointApi {
    static getCards(params: GetPointCardsParams): Promise<PageResponse<PointCardRow>> {
        return instance.get('/points/cards', { params });
    }

    static getPointHistory(params: GetPointHistoryParams): Promise<SliceResponse<PointHistoryRow>> {
        return instance.get('/points/history', { params });
    }
}

export default PointApi;
